var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.counters),function(counter,index){return _c('b-col',{key:index},[_c('counter-item',{attrs:{"data-item":counter}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }